export const EditReferencesRouteTypes = {
  ReturnUrl: 'editReferencesReturnUrl',
  ReturnRoute: 'editReferencesReturnRoute'
};
